<template>
  <div class="DataDownload">
    <div class="DataDownload_content flex_col">
      <el-table
        :data="dowloadList"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        :show-header="false"
      >
        <el-table-column prop="title" width="680"> </el-table-column>
        <el-table-column prop="updateTime" width="150"> </el-table-column>
        <el-table-column>
          <template slot-scope="scope">
            <el-button
              size="small"
              type="primary"
              @click="downLoad(scope.$index, scope.row)"
              >点击下载
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <Paging
        :total="total"
        @onPageChange="onPageChange"
        :current-page="pageNumber"
      ></Paging>
    </div>
  </div>
</template>
<script>
import Paging from "./components/Paging";
import { getFileDowloadApi } from "@/api/index";

export default {
  components: {
    Paging,
  },
  data() {
    return {
      dowloadList: [],
      pageSize: 10,
      pageNumber: 1,
      total: 0,
    };
  },
  mounted() {
    this.getFileDowload();
  },
  methods: {
    //分页
    onPageChange(val) {
      console.log(val);
      this.pageNumber = val;
      this.getFileDowload();
    },
    //下载
    downLoad(index, row) {
      location.href = row.url;
    },
    //列表样式
    tableRowClassName({ row, rowIndex }) {
      if ((rowIndex + 1) % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    //获取下载列表
    getFileDowload() {
      var data = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        type: 1,
      };
      getFileDowloadApi(data).then((res) => {
        console.log(res);
        this.dowloadList = res.data.list;
        this.total = res.data.totalCount;
      });
    },
  },
};
</script>
<style scoped>
.DataDownload_content {
  width: 964px;
  display: flex;
  justify-content: center;
}

.el-table {
  border: 1px solid #e5e5e5;
}

div /deep/ .el-table .warning-row {
  background: #f2f5fa;
}

div /deep/ .el-table .success-row {
  background: #f2f5fa;
}

.el-button--primary {
  background-color: #2968bd;
}

/* .DataDownload_content_file {
} */
</style>



// WEBPACK FOOTER //
// src/views/DataDownload.vue